import {Component, Input} from '@angular/core';
import {EnrollmentModel} from "../../../domain/models/enrollment.model";
import {EnrollmentComponent} from "../EnrollmentComponent";
@Component({
  selector: 'app-default-enrollment',
  standalone: true,
  imports: [],
  templateUrl: './default-enrollment.component.html',
  styleUrl: './default-enrollment.component.css'
})
export class DefaultEnrollmentComponent implements EnrollmentComponent {
  @Input() enrollment!: EnrollmentModel;

  getUpdatedEnrollment(): EnrollmentModel {
    return this.enrollment;
  }

  isFormValid(): boolean {
    return false;
  }

  raiseFormValidations(): void {
  }
}
